var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "text-center mb-6" }, [
        _vm._v(_vm._s(_vm.$t("roomWizard.selectCalendar")))
      ]),
      _c("div", { staticClass: "d-flex mb-4" }, [
        _c(
          "div",
          {
            staticClass:
              "\n        calendar-actions\n        d-flex\n        flex-col\n        md:flex-row\n        gap-4\n        justify-center\n        mb-6\n      "
          },
          [
            _vm.isProviderAllowed("Microsoft")
              ? _c(
                  "div",
                  { staticClass: "calendar-provider-card mx-4" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "calendar-provider-button",
                        attrs: {
                          outlined: "",
                          loading: _vm.loading,
                          disabled: _vm.loading
                        },
                        on: {
                          click: function($event) {
                            return _vm.onCalendarSelect("Microsoft")
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "calendar-provider-button__icon mr-2",
                          attrs: {
                            src: _vm.microsoftCalendarLogo,
                            alt: "Microsoft"
                          }
                        }),
                        _c("span", [_vm._v("Microsoft calendar")])
                      ]
                    ),
                    _vm.isEnabled("Microsoft")
                      ? _c(
                          "div",
                          { staticClass: "calendar-provider-status" },
                          [
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("providers.connectedAs")) +
                                  " " +
                                  _vm._s(_vm.getConnectedEmail("Microsoft")) +
                                  " "
                              )
                            ]),
                            _c("va-button", {
                              staticClass: "mt-2",
                              attrs: {
                                color: "error",
                                size: "s",
                                loading: _vm.loading,
                                cta: _vm.$t("providers.disconnect")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onProviderDisconnect("Microsoft")
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.isProviderAllowed("Google")
              ? _c(
                  "div",
                  { staticClass: "calendar-provider-card mx-4" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "calendar-provider-button",
                        attrs: {
                          outlined: "",
                          loading: _vm.loading,
                          disabled: _vm.loading
                        },
                        on: {
                          click: function($event) {
                            return _vm.onCalendarSelect("Google")
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "calendar-provider-button__icon mr-2",
                          attrs: { src: _vm.googleCalendarLogo, alt: "Google" }
                        }),
                        _c("span", [_vm._v("Google Calendar")])
                      ]
                    ),
                    _vm.isEnabled("Google")
                      ? _c(
                          "div",
                          { staticClass: "calendar-provider-status" },
                          [
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("providers.connectedAs")) +
                                  " " +
                                  _vm._s(_vm.getConnectedEmail("Google")) +
                                  " "
                              )
                            ]),
                            _c("va-button", {
                              staticClass: "mt-2",
                              attrs: {
                                color: "error",
                                size: "s",
                                loading: _vm.loading,
                                cta: _vm.$t("providers.disconnect")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onProviderDisconnect("Google")
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.isProviderAllowed("MicrosoftExchange")
              ? _c(
                  "div",
                  { staticClass: "calendar-provider-card mx-4" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "calendar-provider-button",
                        attrs: {
                          outlined: "",
                          loading: _vm.loading,
                          disabled: _vm.loading
                        },
                        on: { click: _vm.onExchangeActionClick }
                      },
                      [
                        _c("img", {
                          staticClass: "calendar-provider-button__icon mr-2",
                          attrs: {
                            src: _vm.microsoftCalendarLogo,
                            alt: "Microsoft Exchange"
                          }
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("providers.MicrosoftExchange")))
                        ])
                      ]
                    ),
                    _vm.isEnabled("MicrosoftExchange")
                      ? _c(
                          "div",
                          { staticClass: "calendar-provider-status" },
                          [
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("providers.connectedAs")) +
                                  " " +
                                  _vm._s(
                                    _vm.getConnectedEmail("MicrosoftExchange")
                                  ) +
                                  " "
                              )
                            ]),
                            _c("va-button", {
                              staticClass: "mt-2",
                              attrs: {
                                color: "error",
                                size: "s",
                                loading: _vm.loading,
                                cta: _vm.$t("providers.disconnect")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onProviderDisconnect(
                                    "MicrosoftExchange"
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.isLiveCollaborationAllowed
              ? _c(
                  "div",
                  { staticClass: "calendar-provider-card mx-4" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "calendar-provider-button",
                        attrs: {
                          outlined: "",
                          loading: _vm.loading,
                          disabled: _vm.loading
                        },
                        on: {
                          click: function($event) {
                            _vm.liveCollaborationDialogOpen = true
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "calendar-provider-button__icon mr-2",
                          attrs: {
                            src: _vm.liveCollaborationCalendarLogo,
                            alt: "Live Collaboration"
                          }
                        }),
                        _c("span", [_vm._v("Live Collaboration")])
                      ]
                    ),
                    _vm.isLiveCollaborationCalendarEnabled
                      ? _c(
                          "div",
                          { staticClass: "calendar-provider-status" },
                          [
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("providers.connectedAs")) +
                                  " " +
                                  _vm._s(_vm.liveCollaborationUsername) +
                                  " "
                              )
                            ]),
                            _c("va-button", {
                              staticClass: "mt-2",
                              attrs: {
                                color: "error",
                                size: "s",
                                loading: _vm.loading,
                                cta: _vm.$t("providers.disconnect")
                              },
                              on: {
                                click: _vm.onLiveCollaborationCalendarDisable
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "d-flex justify-space-between my-8" },
        [
          !_vm.first
            ? _c("va-button", {
                staticClass: "mr-4",
                attrs: {
                  color: "secondary",
                  type: "outline",
                  cta: _vm.$t("roomWizard.prev")
                },
                on: { click: _vm.onBack }
              })
            : _c("v-spacer"),
          _c("va-button", {
            attrs: { loading: _vm.loading, cta: "Skip" },
            on: { click: _vm.onFinish }
          })
        ],
        1
      ),
      _c("safari-login-dialog", {
        attrs: {
          pendingLoginUrl: _vm.pendingLoginUrl,
          callback: _vm.onPopupcalendarClosed
        },
        model: {
          value: _vm.pendingProvider,
          callback: function($$v) {
            _vm.pendingProvider = $$v
          },
          expression: "pendingProvider"
        }
      }),
      _c("exchange-configuration-dialog", {
        attrs: {
          "initial-config": _vm.exchangeConfig,
          callback: _vm.onExchangeDialogSubmit
        },
        on: { cancel: _vm.onExchangeDialogCancel },
        model: {
          value: _vm.exchangeDialogOpen,
          callback: function($$v) {
            _vm.exchangeDialogOpen = $$v
          },
          expression: "exchangeDialogOpen"
        }
      }),
      _c("live-collaboration-configuration-dialog", {
        attrs: { callback: _vm.onLiveCollaborationDialogSubmit },
        model: {
          value: _vm.liveCollaborationDialogOpen,
          callback: function($$v) {
            _vm.liveCollaborationDialogOpen = $$v
          },
          expression: "liveCollaborationDialogOpen"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }